import React, { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { Menu, MenuItem } from '@mui/material';
import s from './styles.module.scss';
import { ExpandMoreRounded } from '@mui/icons-material';
import { routes } from '@/infrastructure/const/routes';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { useAuth } from '@/infrastructure/context/auth-context';

interface IRecitersListFilterBtnProps {
  className?: string;
}

const RecitersListFilterBtn: React.FC<IRecitersListFilterBtnProps> = (
  props
) => {
  const { className } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const router = useRouter();
  const { pathname } = router;
  const { checkAuth } = useAuth();

  const { t: tButtons } = useTranslation('buttons');

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onItemClick = async (path: string) => {
    handleClose();
    await checkAuth();
    if (path) router.push(path);
  };

  const menuItems = useMemo(() => {
    return [
      {
        title: tButtons('all'),
        path: routes.reciters,
      },
      {
        title: tButtons('mostPopular'),
        path: routes.mostPopular,
      },
      {
        title: tButtons('myFavorite'),
        path: routes.myFavorite,
        authorized: true,
      },
    ];
  }, [tButtons]);

  return (
    <div className={className}>
      <button className={s['filter-btn']} onClick={handleClick}>
        <span>{tButtons('filters')}</span>
        <i>
          <ExpandMoreRounded />
        </i>
      </button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {menuItems.map(
          (menuItem) =>
            pathname !== menuItem.path && (
              <MenuItem key={menuItem.title}>
                {menuItem.authorized ? (
                  <span onClick={() => onItemClick(menuItem.path)}>
                    {menuItem.title}
                  </span>
                ) : (
                  <Link prefetch={false} href={menuItem.path} passHref>
                    <span>{menuItem.title}</span>
                  </Link>
                )}
              </MenuItem>
            )
        )}
      </Menu>
    </div>
  );
};

export default RecitersListFilterBtn;
